import type { UsageRange } from '@/lib/usage/usage'

/**
 * Query keys for the org-usage series so cross-component dedup can't be broken by
 * a hand-retyped array. `orgUsage` is shared by the chart, the stat strip, and
 * the dashboard tiles; keep every reader on this factory.
 */
export const usageKeys = {
  orgUsage: (orgId: string | null, range: UsageRange) =>
    ['org-usage', orgId, range] as const,
  orgCredentialUsage: (orgId: string | null, range: UsageRange) =>
    ['org-credential-usage', orgId, range] as const,
  orgUsagePrevious: (orgId: string | null, range: UsageRange) =>
    ['org-usage-previous', orgId, range] as const,
}
